//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      partyid: this.$route.params.partyid
    }
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    },
    userid () {
      return this.$store.state.user.userid
    }
  },
  mounted () {
  },
  methods: {

  }
}
